export type CapabilityTool =
  | "ARTIFACT:VSTS"
  | "BACKLOG:JIRACLOUD"
  | "BROWAPPAUT:BROWSER"
  | "BROWAPPLIV:BROWSER"
  | "BROWAUT:BROWSER"
  | "BROWLIV:BROWSER"
  | "CI:VSTS"
  | "COLLAB:SLACK"
  | "COPILOT:GITHUBCOPILOT"
  | "ENTERPRISE:GITHUBENTERPRISE"
  | "CS:SONARQUBE"
  | "MONITORING:NEWRELIC"
  | "MONITORING:SPLUNK"
  | "REPO:VSTS"
  | "TESTMAN:VSTS"
  | "UX:FIGMA"
  | "WIKI:CONFLUENCE"
  | "IAC:TERRAFORM"
  | "AZUREDEVOPS:VSTS"
  | "BROWTEST:BROWSER"
  | "GENAI:GENAIBREWERY"
  | "TESTING:QTEST"
  | "TESTDEVELOPMENT:TOSCA";

export const toolOrder: CapabilityTool[] = [
  "BACKLOG:JIRACLOUD",
  "WIKI:CONFLUENCE",
  "COPILOT:GITHUBCOPILOT",
  "ENTERPRISE:GITHUBENTERPRISE",
  "UX:FIGMA",
  "AZUREDEVOPS:VSTS",
  "REPO:VSTS",
  "CS:SONARQUBE",
  "TESTMAN:VSTS",
  "BROWAPPAUT:BROWSER",
  "BROWAPPLIV:BROWSER",
  "BROWAUT:BROWSER",
  "BROWLIV:BROWSER",
  "BROWTEST:BROWSER",
  "IAC:TERRAFORM",
  "CI:VSTS",
  "ARTIFACT:VSTS",
  "MONITORING:NEWRELIC",
  "MONITORING:SPLUNK",
  "COLLAB:SLACK",
  "GENAI:GENAIBREWERY",
  "TESTING:QTEST",
  "TESTDEVELOPMENT:TOSCA",
];

export const toolsDefaultRoles: { [key: string]: string } = {
  DEFAULT: "Basic",
  "UX:FIGMA": "View",
  "MONITORING:NEWRELIC": "Basic",
  "TESTING:QTEST": "Tester",
};
